import React, {createContext, useContext} from 'react';
import {node} from 'prop-types';
import {useTheme} from '@mui/material/styles/index.js';

import {
  getBasicStyle,
  getDefaultFeatureStyle,
  getHoverStyle,
  getSelectedStyle,
} from './styles.js';

const getMapTheme = (muiTheme, mixin = {}) => {
  return {
    feature: {
      default: getDefaultFeatureStyle(muiTheme),
      defaultSecondary: getDefaultFeatureStyle(muiTheme, 'secondary'),
      unselected: getBasicStyle(muiTheme),
      selectedPrimary: getSelectedStyle(muiTheme, 'primary'),
      selectedSecondary: getSelectedStyle(muiTheme, 'secondary'),
      selected: getSelectedStyle(muiTheme),
      hover: getHoverStyle(muiTheme),
    },
    ...mixin,
  };
};

export const MapThemeContext = createContext(null);

// compose this handy short cut
export const useMapTheme = () => {
  return useContext(MapThemeContext);
};

export const MapThemeProvider = ({children}) => {
  const muiTheme = useTheme();
  const mapTheme = getMapTheme(muiTheme);

  return (
    <MapThemeContext.Provider value={mapTheme}>
      {children}
    </MapThemeContext.Provider>
  );
};

MapThemeProvider.propTypes = {
  children: node,
};
